import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";

// Import pages
import Home from './pages/Home';
import Leistungen from './pages/Leistungen';
import LeipzigHome from './pages/leipzig/LeipzigHome';
import LeipzigAbout from './pages/leipzig/LeipzigAbout';
import FreieKapazitaeten from './pages/leipzig/FreieKapazitaeten';
import Stellenausschreibung from './pages/leipzig/Stellenausschreibung';
import HalleHome from './pages/halle/HalleHome';
import HalleUeberUns from './pages/halle/HalleUeberUns';
import HalleStellungangebot from './pages/halle/HalleStellungangebot';
import HalleImpressum from './pages/halle/HalleImpressum';
import HalleDatenschutz from './pages/halle/HalleDatenschutz';
import HalleFreieKapazitaeten from './pages/halle/FreieKapazitaeten';
import HallePflegehelfer from './pages/halle/HallePflegehelfer';
import HallePflegefachkraft from './pages/halle/HallePflegefachkraft';
import Offer from './pages/Offer';
import Pflegehelfer from './pages/karriere/Pflegehelfer';
import Pflegefachkraft from './pages/karriere/Pflegefachkraft';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

// Leistungen Detail Pages
import Grundpflege from './pages/leistungen/Grundpflege';
import Behandlungspflege from './pages/leistungen/Behandlungspflege';
import Hauswirtschaft from './pages/leistungen/Hauswirtschaft';
import Beratung from './pages/leistungen/Beratung';
import Kontakt from './pages/Kontakt';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import CookieConsent from './components/CookieConsent';
import Analytics from './components/Analytics';
import MusicPlayer from './components/MusicPlayer';
import AdminAccess from './components/AdminAccess';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  // Test backend connection
  useEffect(() => {
    const helloWorldApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Analytics />
        <AdminAccess />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leipzig" element={<LeipzigHome />} />
          <Route path="/leipzig/ueber-uns" element={<LeipzigAbout />} />
          <Route path="/leipzig/freie-kapazitaeten" element={<FreieKapazitaeten />} />
          <Route path="/leipzig/stellenausschreibung" element={<Stellenausschreibung />} />
          <Route path="/leipzig/karriere/pflegehelfer" element={<Pflegehelfer />} />
          <Route path="/leipzig/karriere/pflegefachkraft" element={<Pflegefachkraft />} />
          <Route path="/halle" element={<HalleHome />} />
          <Route path="/halle/ueber-uns" element={<HalleUeberUns />} />
          <Route path="/halle/karriere" element={<HalleStellungangebot />} />
          <Route path="/halle/karriere/pflegehelfer" element={<HallePflegehelfer />} />
          <Route path="/halle/karriere/pflegefachkraft" element={<HallePflegefachkraft />} />
          <Route path="/halle/freie-kapazitaeten" element={<HalleFreieKapazitaeten />} />
          <Route path="/halle/impressum" element={<HalleImpressum />} />
          <Route path="/halle/datenschutz" element={<HalleDatenschutz />} />
          <Route path="/leistungen/grundpflege" element={<Grundpflege />} />
          <Route path="/leistungen/behandlungspflege" element={<Behandlungspflege />} />
          <Route path="/leistungen/hauswirtschaft" element={<Hauswirtschaft />} />
          <Route path="/leistungen/beratung" element={<Beratung />} />
          <Route path="/angebot" element={<Offer />} />
          <Route path="/kontakt" element={<Kontakt />} />
          {/* Hidden admin portal (reachable via footer button or Ctrl+X) */}
          <Route path="/portal-gsh" element={<AdminLogin />} />
          <Route path="/portal-gsh/dashboard" element={<Admin />} />
          {/* Block direct /admin access */}
          <Route path="/admin" element={<Navigate to="/" replace />} />
          <Route path="/admin/login" element={<Navigate to="/" replace />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <CookieConsent />
        <MusicPlayer />
      </BrowserRouter>
    </div>
  );
}

export default App;